import { type Booking, type BookingClient, type EmailTemplatePurpose } from '../../../models/Scheduling'
import { clientDisplayName, clientKey } from '../shared/schedulingDisplay'

export interface ClientInviteLink {
  name: string
  url: string
}

const matchingClient = (booking: Booking, client: BookingClient): BookingClient | undefined => {
  const key = clientKey(client)
  return key === '' ? undefined : booking.clients.find((candidate) => clientKey(candidate) === key)
}

export const clientInviteUrl = (booking: Booking, client: BookingClient): string | undefined => matchingClient(booking, client)?.inviteUrl

export const unsubscribeLink = (client: BookingClient | undefined, purpose: EmailTemplatePurpose): string | undefined =>
  client?.unsubscribeUrl ? `${client.unsubscribeUrl}?purpose=${purpose}` : undefined

export const clientUnsubscribeLink = (booking: Booking, client: BookingClient, purpose: EmailTemplatePurpose): string | undefined =>
  unsubscribeLink(matchingClient(booking, client), purpose)

export const withDraftInviteUrls = (clients: BookingClient[], draft: Booking | null): BookingClient[] =>
  clients.map((client) => {
    const match = draft ? matchingClient(draft, client) : undefined
    if (!match?.inviteUrl) {
      return client
    }
    return match.unsubscribeUrl ? { ...client, inviteUrl: match.inviteUrl, unsubscribeUrl: match.unsubscribeUrl } : { ...client, inviteUrl: match.inviteUrl }
  })

export const collectClientInviteLinks = (clients: BookingClient[]): ClientInviteLink[] =>
  clients.flatMap((client) => (client.inviteUrl ? [{ name: clientDisplayName(client), url: client.inviteUrl }] : []))

export const formatClientInviteLinks = (links: ClientInviteLink[]): string =>
  links.length === 1 ? links[0].url : links.map(({ name, url }) => `${name} - ${url}`).join('\n')
